import React, {useState} from 'react';
import ShowTabsList from "../../../common/ui/show-tabs-list";
import {DEFAULT_MARKETING_DASHBOARD_TAB, MARKETING_DASHBOARD_TABS_LIST} from "../../constants/marketing.constant";
import SelectedProductList from "../products/selected-product-list";
import MediaList from "../media/media-list";
import FacebookDashboard from "../../../facebook/components/facebook/facebook-dashboard";

const tabsList = MARKETING_DASHBOARD_TABS_LIST;

const MarketingDashboard = () => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_MARKETING_DASHBOARD_TAB);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start items-center m-2 pb-2">
                        <div className="text-xl">
                            Marketing
                        </div>

                        <div className={'flex ml-4'}>
                            <ShowTabsList
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                tabsList={tabsList}/>
                        </div>
                    </div>


                    <div className="justify-start">

                        <div className="px-4">

                            {selectedTab?.key === 'selected-products' &&
                                <div>
                                    <SelectedProductList/>
                                </div>
                            }

                            {selectedTab?.key === 'media' &&
                                <div>
                                    <MediaList/>
                                </div>
                            }

                            {selectedTab?.key === 'facebook' &&
                                <div>
                                    <FacebookDashboard/>
                                </div>
                            }

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default MarketingDashboard
